module.exports = __webpack_public_path__ + "img/right1-mobile.b5d7cc05.png";